import OtpInput from '@enroly/react-otp-input';

export interface ITheme {
  containerJustifyContent?: string;
  margin?: string;
  widthPx?: number;
  heightPx?: number;
  fontSize?: number;
  color?: string;
}

export interface IProps {
  onChange: (value: string) => void;
  value: string;
  digits: number;
  theme?: ITheme;
}

const TotpCodeInput: React.FC<IProps> = ({ onChange, value, digits, theme, ...otherProps }) => {
  const expandedTheme = { ...defaultTheme, ...theme };
  return (
    <div data-selector="mfa-otp-input">
      <OtpInput
        isInputNum
        value={value}
        onChange={onChange}
        shouldAutoFocus={true}
        numInputs={6}
        containerStyle={{
          justifyContent: expandedTheme.containerJustifyContent,
          maxWidth: expandedTheme.containerMaxWidth,
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
        inputStyle={{
          margin: expandedTheme.margin,
          width: expandedTheme.widthPx,
          height: expandedTheme.heightPx,
          fontSize: expandedTheme.fontSize,
          color: expandedTheme.color,
          backgroundColor: expandedTheme.backgroundColor,
          borderWidth: expandedTheme.borderWidth,
          borderStyle: expandedTheme.borderStyle,
          borderColor: expandedTheme.borderColor,
          borderRadius: expandedTheme.borderRadius,
        }}
        {...otherProps}
      />
    </div>
  );
};

const defaultTheme = {
  containerJustifyContent: 'center',
  containerMaxWidth: '400px',
  backgroundColor: 'var(--ds-colors-chakra-body-bg)',
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: 'var(--ds-colors-chakra-border-color)',
  borderRadius: 'var(--ds-radii-lg)',
  margin: '0 var(--ds-space-1)',
  widthPx: '100%',
  heightPx: 64,
  fontSize: 28,
  color: 'var(--ds-colors-chakra-body-text)',
};

export default TotpCodeInput;
